import React from 'react';
import { Reveal } from './Reveal';
export function ProductSection() {
  return <section className="py-14 px-6 bg-white" data-id="element-182">
      <Reveal data-id="element-183">
        <div className="bg-gradient-to-br from-ink to-[#2C2820] rounded-[20px] py-8 px-6 mb-7 relative overflow-hidden" data-id="element-184">
          <div className="absolute -top-10 -right-10 w-[180px] h-[180px] rounded-full bg-[radial-gradient(circle,rgba(92,122,101,0.3)_0%,transparent_70%)]" data-id="element-185"></div>

          <span className="text-[10px] font-semibold tracking-[0.14em] uppercase text-gold mb-3 block" data-id="element-186">
            Tomo principal · PDF digital
          </span>
          <h2 className="font-serif text-[38px] font-semibold leading-[1.1] mb-1.5 text-[#E7A82A]" data-id="element-187">
            Código
            <br data-id="element-188" />
            Hormonal
          </h2>
          <p className="font-serif italic mb-6 text-[18px] text-[#604208]" data-id="element-189">
            La guía práctica para mujeres con desequilibrio hormonal
          </p>

          <div className="flex flex-col gap-2" data-id="element-190">
            <div className="flex items-center gap-2.5 text-[13px] text-[#E7A82A]" data-id="element-191">
              <span className="w-1.5 h-1.5 rounded-full bg-sage shrink-0" data-id="element-192"></span>
              5 capítulos · +50 páginas de contenido real
            </div>
            <div className="flex items-center gap-2.5 text-[13px] text-[#E7A82A]" data-id="element-193">
              <span className="w-1.5 h-1.5 rounded-full bg-sage shrink-0" data-id="element-194"></span>
              Sin tecnicismos, sin rodeos
            </div>
            <div className="flex items-center gap-2.5 text-[13px] text-[#E7A82A]" data-id="element-195">
              <span className="w-1.5 h-1.5 rounded-full bg-sage shrink-0" data-id="element-196"></span>
              Basado en evidencia científica actual
            </div>
            <div className="flex items-center gap-2.5 text-[13px] text-[#E7A82A]" data-id="element-197">
              <span className="w-1.5 h-1.5 rounded-full bg-sage shrink-0" data-id="element-198"></span>
              Escrito para el contexto latinoamericano
            </div>
          </div>
        </div>

        <span className="inline-block text-[10px] font-semibold tracking-[0.14em] uppercase text-sage mb-3" data-id="element-199">
          Lo que vas a aprender
        </span>

        <div className="flex flex-col gap-3" data-id="element-200">
          <Reveal delay={100} data-id="element-201">
            <div className="flex items-start gap-3.5 p-4 bg-cream-dark rounded-xl" data-id="element-202">
              <span className="font-serif text-[28px] font-light text-terra leading-none shrink-0 w-7" data-id="element-203">
                1
              </span>
              <div data-id="element-204">
                <p className="text-[14px] font-semibold text-ink mb-1 leading-[1.3]" data-id="element-205">
                  Las 5 hormonas que controlan todo
                </p>
                <p className="text-[12px] text-ink-soft leading-[1.5]" data-id="element-206">
                  Estrógeno, progesterona, cortisol, insulina, testosterona:
                  cómo actúan y por qué fallan.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={200} data-id="element-207">
            <div className="flex items-start gap-3.5 p-4 bg-cream-dark rounded-xl" data-id="element-208">
              <span className="font-serif text-[28px] font-light text-terra leading-none shrink-0 w-7" data-id="element-209">
                2
              </span>
              <div data-id="element-210">
                <p className="text-[14px] font-semibold text-ink mb-1 leading-[1.3]" data-id="element-211">
                  Síntomas que el médico descarta
                </p>
                <p className="text-[12px] text-ink-soft leading-[1.5]" data-id="element-212">
                  Lo que cada síntoma significa en términos hormonales y qué
                  análisis pedir.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={300} data-id="element-213">
            <div className="flex items-start gap-3.5 p-4 bg-cream-dark rounded-xl" data-id="element-214">
              <span className="font-serif text-[28px] font-light text-terra leading-none shrink-0 w-7" data-id="element-215">
                3
              </span>
              <div data-id="element-216">
                <p className="text-[14px] font-semibold text-ink mb-1 leading-[1.3]" data-id="element-217">
                  Alimentación según tu fase del ciclo
                </p>
                <p className="text-[12px] text-ink-soft leading-[1.5]" data-id="element-218">
                  Qué comer en cada una de las 4 fases para apoyar tus hormonas
                  naturalmente.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={400} data-id="element-219">
            <div className="flex items-start gap-3.5 p-4 bg-cream-dark rounded-xl" data-id="element-220">
              <span className="font-serif text-[28px] font-light text-terra leading-none shrink-0 w-7" data-id="element-221">
                4
              </span>
              <div data-id="element-222">
                <p className="text-[14px] font-semibold text-ink mb-1 leading-[1.3]" data-id="element-223">
                  Protocolo de 30 días
                </p>
                <p className="text-[12px] text-ink-soft leading-[1.5]" data-id="element-224">
                  Sueño, movimiento y manejo del estrés: los 3 pilares que el
                  cuerpo necesita.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={500} data-id="element-225">
            <div className="flex items-start gap-3.5 p-4 bg-cream-dark rounded-xl" data-id="element-226">
              <span className="font-serif text-[28px] font-light text-terra leading-none shrink-0 w-7" data-id="element-227">
                5
              </span>
              <div data-id="element-228">
                <p className="text-[14px] font-semibold text-ink mb-1 leading-[1.3]" data-id="element-229">
                  SOP, perimenopausia y menopausia
                </p>
                <p className="text-[12px] text-ink-soft leading-[1.5]" data-id="element-230">
                  Un capítulo completo para cada condición con información
                  accionable.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </Reveal>
    </section>;
}